import { render, staticRenderFns } from "./ESGRating.vue?vue&type=template&id=3b080e7c&scoped=true"
import script from "./ESGRating.vue?vue&type=script&lang=js"
export * from "./ESGRating.vue?vue&type=script&lang=js"
import style0 from "./ESGRating.vue?vue&type=style&index=0&id=3b080e7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b080e7c",
  null
  
)

export default component.exports